export const iconSizes = {
  xs: { name: 'xs', size: 0.125 },
  small: { name: 'small', size: 0.25 },
  medium: { name: 'medium', size: 0.5 },
  large: { name: 'large', size: 0.75 },
  xl: { name: 'xl', size: 1 },
};

export const hotspotTypes = {
  EMBED: 'embed',
  HIGHLIGHT: 'highlight',
  IMAGE: 'image',
  LINK: 'link',
  STOP: 'stop',
  VIDEO: 'video',
};
